import { omsTotalsTransformer } from '../totalsTransformer';


export const omsOrderDataTransformer = (data:OmsOrderDataType) => ({
  paymentMethod : data.paymentMethod || '',
  paymentType: data.paymentType || '',
  createdAt : data.createdAt || '',
  status : data.status || '',
  entityId : data.entityId || '',
  orderId : data.orderNo || '',
  itemsCount : data.itemsCount || -1,
  subType : data.subType || -1,
  itemsQty : data.itemsQty || -1,
  totals : omsTotalsTransformer(data.orderSummary || {}),
});

